// Download card for a CSV emitted by the rhinoanalyst service's export_csv
// tool. The file is built in the browser from the rows the answer used and is
// never stored anywhere.

import React, { useState } from 'react';
import PropTypes from 'prop-types';

const escapeCell = (value) => {
  if (value === null || value === undefined) return '';
  const s = String(value);
  // Neutralise spreadsheet formula injection, then quote where needed.
  const safe = /^[=+\-@\t\r]/.test(s) ? `'${s}` : s;
  return /[",\n\r]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
};

export const buildCsv = (columns, rows) => {
  const header = columns.map((c) => escapeCell(c.name)).join(',');
  const body = rows.map((r) => columns.map((c) => escapeCell(r[c.key])).join(','));
  const bom = String.fromCharCode(0xfeff); // helps Excel read UTF-8
  return `${bom}${[header, ...body].join('\r\n')}\r\n`;
};

const ReggieCsv = ({ payload }) => {
  const { filename, columns, rows } = payload;
  const [done, setDone] = useState(false);
  if (!Array.isArray(rows) || !Array.isArray(columns) || !columns.length) return null;

  const download = () => {
    const blob = new Blob([buildCsv(columns, rows)], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'export.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    setDone(true);
    setTimeout(() => setDone(false), 2000);
  };

  return (
    <div className="rhinoanalyst__file" data-cypress="reggieCsv">
      <div className="rhinoanalyst__file__info">
        <div className="rhinoanalyst__file__name">{filename}</div>
        <div className="rhinoanalyst__file__meta">{rows.length} row{rows.length === 1 ? '' : 's'} &middot; {columns.length} column{columns.length === 1 ? '' : 's'}</div>
      </div>
      <button type="button" className="rhinoanalyst__file__button" onClick={download}>
        {done ? 'Downloaded' : 'Download CSV'}
      </button>
    </div>
  );
};

ReggieCsv.propTypes = {
  payload: PropTypes.shape({
    filename: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string, name: PropTypes.string })),
    rows: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

export default ReggieCsv;
